import '../Inscription.less';
import {Menu , Row, Col} from 'antd';
import {  HomeOutlined} from '@ant-design/icons';
import React, { Component } from "react";
import cabezal from '../Cabezal.jpg'
import {NavLink} from "react-router-dom";


/** *
* *Menu used in all User Views
*/
class UserMenu extends Component {
  render() {  
    return (
        <div>
        <Row>
                <Col><NavLink to="/casa"><img src= {cabezal} style={{width:'100%', height:'100%'}}/></NavLink></Col>
              </Row>
                <Row justify="start" >
                <Col span={24}>
                  <Menu  mode="horizontal" style={{borderBottom:'none'}}>
                    <Menu.Item key="home" style={{borderBottom:'none'}} icon={<HomeOutlined style={{ fontSize: '26px'}}/>} >
                      <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/casa"> Inicio</NavLink>
                    </Menu.Item>
                  </Menu>
                </Col>

              </Row>
          </div>
    );
  }
}
export default UserMenu;


